import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Checkbox } from 'antd';
import { crud_options } from './statics';
import { checkFieldStatus, firstLetterLowCase } from '../../../../shared/helpers';
import { editGroupModelPermissionsRequest } from '../redux/actions/edit_group_model_permissions.actions';
import { getGroupModelFieldPermissionsRequest } from '../redux/actions/get_group_model_field_permissions.actions';
import GroupModelFields from './GroupModelFields';

const mapStateToProps = (state) => {
    const { moduleOptionFields, url_active, group_id } = state.UserManagement.User_group_update;
    return { moduleOptionFields, url_active, group_id };
}; const
    { TabPane } = Tabs;

export default connect(mapStateToProps, null)(class GroupModels extends Component {
  getModelStructureHandler = url => this.props.dispatch(getGroupModelFieldPermissionsRequest(url));

  editModelPermission = ({ target: { url, title, permissions } }) => {
      const status = title[0].toLowerCase();
      permissions = permissions[this.props.url_active].permissions;
      permissions.includes(status) ? permissions.splice(permissions.indexOf(status), 1) : permissions = [...permissions, status];
      this.props.dispatch(editGroupModelPermissionsRequest(url, permissions, 'model'));
  };

  render() {
      const { moduleOptionFields, url_active } = this.props;

      return (
          <Tabs
              defaultActiveKey="undefined"
              tabPosition="left"
              className="margin-top-10-px"
              onTabClick={this.getModelStructureHandler}
          >
              {moduleOptionFields && Object.keys(moduleOptionFields).map((models) => {
                  const model = moduleOptionFields[models];
                  return model.modelName
            && (
                <TabPane tab={model.modelName} key={model.URL} style={{ marginTop: 9, fontStyle: 'italic', marginRight: 40 }}>
                    {url_active
                && (
                    <div style={{ marginBottom: 20 }}>
                        {`${model.modelName}`}
                        {' '}
                        Model Permissions:
                        <span style={{ marginLeft: 10 }}>
                            {crud_options.map((option, index) => (
                                <Checkbox
                                    key={index}
                                    title={option.title}
                                    url={model.URL}
                                    permissions={model.modulesPermissions && model.modulesPermissions}
                                    checked={checkFieldStatus(model.crud, option, moduleOptionFields[url_active].modulesPermissions[url_active].permissions)}
                                    onChange={this.editModelPermission}
                                    disabled={!model.crud[firstLetterLowCase(option.title)]}
                                >{option.title}
                                </Checkbox>
                            ))}
                        </span>
                    </div>
                )}
                    <GroupModelFields />
                </TabPane>
            );
              })}
          </Tabs>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/GroupModels.js